import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_URL, setCurrencyConfig } from "../lib/utils";
import { useAuth } from "./AuthContext";
import { saveBrand } from "../components/pwa/WelcomeSplash";

const CurrencyContext = createContext(null);

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const { token, isAuthenticated } = useAuth();
  const [currencyInfo, setCurrencyInfo] = useState({
    currency: "AOA",
    symbol: "Kz",
    rate: 1,
    rates: {},
  });

  const applySettings = useCallback((s) => {
    saveBrand(s);
    const currency = s?.currency || "AOA";
    const rates = s?.exchange_rates || {};
    const rate = currency === "AOA" ? 1 : rates[currency] || 1;
    const symbol = s?.currency_symbol || "Kz";
    setCurrencyConfig({ currency, symbol, rate });
    setCurrencyInfo({ currency, symbol, rate, rates });
  }, []);

  const refreshCurrency = useCallback(async () => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await axios.get(`${API_URL}/settings`, {
        headers,
        withCredentials: true,
      });
      applySettings(res.data);
    } catch {
      // mantém configuração atual
    }
  }, [token, applySettings]);

  useEffect(() => {
    if (isAuthenticated) {
      refreshCurrency();
    }
  }, [isAuthenticated, refreshCurrency]);

  return (
    <CurrencyContext.Provider value={{ ...currencyInfo, refreshCurrency, applySettings }}>
      {children}
    </CurrencyContext.Provider>
  );
};
